import { useEffect, useState, useMemo } from "react";
import { usePagination } from "@components/index";

export const useUserManagementData = () => {
  const [openAddNewUserModal, setOpenAddNewUserModal] = useState(false);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [currentUserList, setCurrentUserList] = useState([]);
  const [filters, setFilters] = useState({
    searchValue: "", // Single search field
    role: "",
    status: "",
  });

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = {
          users: [
            {
              id: "AGENT1001",
              role: "ops",
              status: "active",
              name: "Shrishti Katiyar",
              email: "shristi.katiyar@acrossassist.com",
              phoneNumber: "9876543210",
              createdAt: "2025-01-10T09:30:00Z",
            },
            {
              id: "CLIENT2001",
              role: "client",
              status: "active",
              name: "Deepak Gupta",
              email: "deepak.gupta@example.com",
              phoneNumber: "9988776655",
              createdAt: "2025-01-09T10:20:00Z",
            },
            {
              id: "AGENT1002",
              role: "ops",
              status: "inactive",
              name: "Priya Mehta",
              email: "priya.mehta@example.com",
              phoneNumber: "9865321470",
              createdAt: "2025-01-12T11:15:00Z",
            },
          ],
        };
        const data = await JSON.parse(response);
        setCurrentUserList(data);
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };

    fetchUserList();
  }, []);

  // Filter users based on current filters
  const filteredUserList = useMemo(() => {
    return currentUserList.filter((user) => {
      // Global search across name, email, and phone
      const matchesSearch =
        !filters.searchValue ||
        user.name.toLowerCase().includes(filters.searchValue.toLowerCase()) ||
        user.email.toLowerCase().includes(filters.searchValue.toLowerCase()) ||
        user.phoneNumber.includes(filters.searchValue);

      const matchesRole = !filters.role || user.role === filters.role;

      const matchesStatus = !filters.status || user.status === filters.status;

      return matchesSearch && matchesRole && matchesStatus;
    });
  }, [currentUserList, filters]);

  const handleAddNewUser = () => {
    setOpenAddNewUserModal(true);
  };

  const onEditUser = (user) => {
    setEditingUser(user);
    setOpenEditUserModal(true);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      searchValue: "",
      role: "",
      status: "",
    });
  };

  // Pagination functionality
  const {
    currentPage,
    currentData: paginatedUserList,
    handlePageChange,
    totalPages,
  } = usePagination(filteredUserList, 10);

  return {
    handleAddNewUser,
    openAddNewUserModal,
    setOpenAddNewUserModal,
    openEditUserModal,
    setOpenEditUserModal,
    editingUser,
    setEditingUser,
    currentUserList: paginatedUserList, // Now returns paginated data
    allUserList: filteredUserList, // Full filtered list for pagination component
    onEditUser,
    filters,
    handleFilterChange,
    handleClearFilters,
    // Pagination props
    currentPage,
    handlePageChange,
    totalPages,
  };
};
